/* eslint class-methods-use-this: 0 */
/* eslint guard-for-in: 0 */
/* eslint no-restricted-syntax: 0 */
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import { Session, SessionKeys } from 'common/services/-RFC.session.js';

(() => {

    const _serviceDependencies = ['$scope', '$window', '$state', '$timeout'];
    let _$scope;
    let _$window;
    let _$state;
    let _$timeout;

    /**
     * @ngdoc service
     * @name controllers.ChangeLang
     *
     * @description
     * change the language in the authentication pages - modal controller
     */
    class ChangeLang {

        /**
         * @param  {any} $scope
         * @param  {any} $window
         * @param  {any} $timeout
         */
        constructor($scope, $window, $state, $timeout) {

            _$scope = $scope;
            _$window = $window;
            _$state = $state;
            _$timeout = $timeout;
            _$scope.languages = [];
            _$scope.changeLanguage = this.changeLanguage;
            _$scope.currentLanguage = _$window.location.pathname;

            angular.forEach(CWCONFIG.languages, (value, key) => {

                _$scope.languages.push({ code: key, name: value });

            });

        }

        /**
         * @ngdoc controllers
         * @name controllers.ChangeLang#changeLanguage
         * @methodOf controllers.ChangeLang
         *
         * @description
         * change the language
         */
        changeLanguage(inputLanguage) {

            _$timeout(() => {

                // Keep the received params in auth page
                const extraUrlParams = Session.getValue(SessionKeys.ExtraUrlParams);
                if (extraUrlParams) {

                    _$window.location.href = `${_$window.location.href.replace(CWCONFIG.language, inputLanguage)}${extraUrlParams}`;

                } else {

                    _$window.location.pathname =
                        _$window.location.pathname.replace(CWCONFIG.language, inputLanguage);

                }

            }, 100);

            Mixpanel.send('ConnectWeb My Account Open', {
                Language: inputLanguage,
            });
            _$state.go(_$state.current.name.replace('.ltb', ''));

        }

    }

    _serviceDependencies.push(ChangeLang);

    angular.module('controllers')
        .controller('ChangeLangCtrl', _serviceDependencies);

})();



// WEBPACK FOOTER //
// ./scripts/controllers/modals/change-lang/change-lang.js